<template>
    <div class="fixed right-0 bottom-0 m-3 z-50">
        <div class="flex flex-col space-y-2 bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-2">
            <!-- WhatsApp -->
            <a :href="`https://wa.me/${whatsappNumber}?text=Halo,%20saya%20ingin%20bertanya%20tentang%20penerimaan%20siswa%20PENABUR%20Jakarta`"
                target="_blank" rel="noopener noreferrer" @click="trackSocial('whatsapp', whatsappNumber)"
                class="social-btn pulse-whatsapp bg-green-500 hover:bg-green-600 text-white p-2.5 rounded-xl shadow-lg"
                title="WhatsApp">
                <Icon icon="ic:baseline-whatsapp" class="w-5 h-5" />
            </a>

            <!-- Instagram -->
            <a :href="instagramUrl" target="_blank" rel="noopener noreferrer"
                @click="trackSocial('instagram', instagramUrl)"
                class="social-btn bg-[#2F5085] hover:bg-[#273f6a] text-white p-2.5 rounded-xl shadow-lg"
                title="Instagram">
                <Icon icon="mdi:instagram" class="w-5 h-5" />
            </a>

            <!-- TikTok -->
            <a :href="tiktokUrl" target="_blank" rel="noopener noreferrer" @click="trackSocial('tiktok', tiktokUrl)"
                class="social-btn bg-[#2F5085] hover:bg-[#273f6a] text-white p-2.5 rounded-xl shadow-lg" title="TikTok">
                <Icon icon="ic:baseline-tiktok" class="w-5 h-5" />
            </a>

            <!-- Facebook -->
            <a :href="facebookUrl" target="_blank" rel="noopener noreferrer"
                @click="trackSocial('facebook', facebookUrl)"
                class="social-btn bg-[#2F5085] hover:bg-[#273f6a] text-white p-2.5 rounded-xl shadow-lg"
                title="Facebook">
                <Icon icon="ic:baseline-facebook" class="w-5 h-5" />
            </a>
        </div>
    </div>
</template>

<script setup>

import { useSocialTrack } from '@/composables/useSocialTrack'

const { trackSocial } = useSocialTrack()

// Props for social media URLs with PENABUR defaults
const props = defineProps({
    whatsappNumber: {
        type: String,
        default: '6287820200031' // PENABUR Jakarta WhatsApp
    },
    instagramUrl: {
        type: String,
        default: 'https://instagram.com/bpkpenaburjakarta'
    },
    youtubeUrl: {
        type: String,
        default: 'https://youtube.com/@BPKPENABURJakarta'
    },
    tiktokUrl: {
        type: String,
        default: 'https://tiktok.com/@bpkpenaburjakarta'
    },
    facebookUrl: {
        type: String,
        default: 'https://facebook.com/BPKPENABURJakarta'
    }
})
</script>

<style scoped>
/* Subtle pulse animation for WhatsApp */
@keyframes pulse-green {

    0%,
    100% {
        box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.4);
    }

    50% {
        box-shadow: 0 0 0 6px rgba(34, 197, 94, 0);
    }
}

.pulse-whatsapp {
    animation: pulse-green 3s infinite;
}

/* Mobile responsiveness */
@media (max-width: 640px) {
    .social-btn {
        padding: 0.5rem;
    }

    .social-btn .w-5 {
        width: 1rem;
        height: 1rem;
    }

    .fixed>div {
        padding: 0.5rem;
    }

    .flex-col {
        gap: 0.25rem;
    }
}

/* Enhanced shadow for better visibility */
.shadow-2xl {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

/* Smooth transitions */
* {
    transition: all 0.3s ease;
}
</style>